export default {
    fhe: {
        theme: {
            palette: {
                primary: {
                    light: 'rgba(203, 225, 222, 1)',
                    main: 'rgba(65, 155, 145, 1)',
                    dark: 'rgba(21, 79, 71, 1)',
                },
                secondary: {
                    light: 'rgba(210, 227, 175, 1)',
                    main: 'rgba(129, 189, 0, 1)',
                    dark: 'rgba(54, 101, 0, 1)',
                },
            },
        },
    },
    myfhe: {
        theme: {
            palette: {
                primary: {
                    light: 'rgb(232,138,102)',
                    main: 'rgba(232, 73, 15, 1)',
                    dark: 'rgb(232,49,0, 1)',
                },
                secondary: {
                    light: 'rgb(255,250,169, 1)',
                    main: 'rgba(255, 215, 21, 1)',
                    dark: 'rgb(255,197,0, 1)',
                },
            },
        },
    },
    fhepool: {
        theme: {
            palette: {
                primary: {
                    light: 'rgb(143,199,248)',
                    main: 'rgba(31, 140, 234, 1)',
                    dark: 'rgb(15,61,103)',
                },
                secondary: {
                    light: 'rgb(184,232,242)',
                    main: 'rgba(88, 208, 223, 1)',
                    dark: 'rgb(37,88,94)',
                },
            },
        },
    },
    cocoon: {
        theme: {
            palette: {
                primary: {
                    light: 'rgba(255, 101, 72, 1)',
                    main: 'rgba(214, 46, 29, 1)',
                    dark: 'rgba(156, 0, 0, 1)',
                },
                secondary: {
                    light: 'rgba(194, 195, 210, 1)',
                    main: 'rgba(146, 147, 161, 1)',
                    dark: 'rgba(100, 101, 114, 1)',
                },
            },
        },
    },
    homing: {
        theme: {
            palette: {
                primary: {
                    light: 'rgb(191, 65, 92, 1)',
                    main: 'rgba(138, 0, 51, 1)',
                    dark: 'rgb(86, 0, 12, 1)',
                },
                secondary: {
                    light: 'rgba(144, 141, 141, 1)',
                    main: 'rgba(99, 96, 96, 1)',
                    dark: 'rgba(57, 54, 54, 1)',
                },
            },
        },
    },
    fheconnect: {
        theme: {
            palette: {
                primary: {
                    light: 'rgba(210, 230, 230, 1)',
                    main: 'rgba(65, 155, 145, 1)',
                    dark: 'rgba(21, 79, 71, 1)',
                },
                secondary: {
                    light: 'rgba(214, 214, 224, 1)',
                    main: 'rgba(146, 147, 161, 1)',
                    dark: 'rgba(46, 46, 58, 1)',
                },
            },
        },
    },
    lacin: {
        theme: {
            palette: {
                primary: {
                    light: 'rgb(208, 78, 60, 1)',
                    main: 'rgba(153, 26, 20, 1)',
                    dark: 'rgb(100, 0, 0, 1)',
                },
                secondary: {
                    light: 'rgba(144, 144, 144, 1)',
                    main: 'rgba(100, 99, 99, 1)',
                    dark: 'rgba(57, 57, 57, 1)',
                },
            },
        },
    },
    domalisa: {
        theme: {
            palette: {
                primary: {
                    light: 'rgba(94, 87, 179, 1)',
                    main: 'rgba(43, 46, 131, 1)',
                    dark: 'rgba(0, 9, 85, 1)',
                },
                secondary: {
                    light: 'rgb(255, 86, 63, 1)',
                    main: 'rgba(227, 6, 19, 1)',
                    dark: 'rgb(168, 0, 0, 1)',
                },
            },
        },
    },
    accesshabitat: {
        theme: {
            palette: {
                primary: {
                    light: 'rgba(239, 249, 78, 1)',
                    main: 'rgba(185, 198, 2, 1)',
                    dark: 'rgba(133, 150, 0, 1)',
                    contrastText: 'rgba(255, 255, 255, 1)',
                },
                secondary: {
                    light: 'rgb(80, 80, 80, 1)',
                    main: 'rgba(40, 40, 40, 1)',
                    dark: 'rgb(0, 0, 0, 1)',
                    contrastText: 'rgba(255, 255, 255, 1)',
                },
            },
        },
    },
    maestro: {
        theme: {
            palette: {
                primary: {
                    light: 'rgba(135, 226, 98, 1)',
                    main: 'rgba(83, 175, 50, 1)',
                    dark: 'rgba(22, 127, 0, 1)',
                    contrastText: 'rgba(255, 255, 255, 1)',
                },
                secondary: {
                    light: 'rgb(130, 242, 255, 1)',
                    main: 'rgba(68, 191, 239, 1)',
                    dark: 'rgb(0, 143, 188, 1)',
                    contrastText: 'rgba(255, 255, 255, 1)',
                },
            },
        },
    },
    weezeo: {
        theme: {
            palette: {
                primary: {
                    light: 'rgba(27, 198, 255, 1)',
                    main: 'rgba(27, 198, 255, 1)',
                    dark: 'rgba(0, 206, 206, 1)',
                    contrastText: 'rgba(255, 255, 255, 1)',
                },
                secondary: {
                    light: 'rgb(38, 38, 38, 1)',
                    main: 'rgba(0, 0, 0, 1)',
                    dark: 'rgb(0, 0, 0, 1)',
                    contrastText: 'rgba(255, 255, 255, 1)',
                },
            },
        },
    },
    niceenergie: {
        theme: {
            palette: {
                primary: {
                    light: 'rgba(251, 186, 0, 1)',
                    main: 'rgba(251, 186, 0, 1)',
                    dark: 'rgba(0, 206, 206, 1)',
                    contrastText: 'rgba(255, 255, 255, 1)',
                },
                secondary: {
                    light: 'rgb(87, 87, 86, 1)',
                    main: 'rgba(0, 0, 0, 1)',
                    dark: 'rgb(0, 0, 0, 1)',
                    contrastText: 'rgba(255, 255, 255, 1)',
                },
            },
        },
    },
    mghabitat: {
        theme: {
            palette: {
                primary: {
                    light: 'rgba(11, 125, 65, 1)',
                    main: 'rgba(11, 125, 65, 1)',
                    dark: 'rgba(0, 206, 206, 1)',
                    contrastText: 'rgba(255, 255, 255, 1)',
                },
                secondary: {
                    light: 'rgb(189, 218, 0, 1)',
                    main: 'rgba(0, 0, 0, 1)',
                    dark: 'rgb(0, 0, 0, 1)',
                    contrastText: 'rgba(255, 255, 255, 1)',
                },
            },
        },
    },
    idealys: {
        theme: {
            palette: {
                primary: {
                    light: 'rgba(38, 44, 46, 1)',
                    main: 'rgba(38, 44, 46, 1.0)',
                    dark: 'rgba(0, 206, 206, 1)',
                    contrastText: 'rgba(255, 255, 255, 1)',
                },
                secondary: {
                    light: 'rgb(243, 121, 52, 1)',
                    main: 'rgba(243, 121, 52, 1)',
                    dark: 'rgb(0, 0, 0, 1)',
                    contrastText: 'rgba(255, 255, 255, 1)',
                },
            },
        },
    },
    inogreen: {
        theme: {
            palette: {
                secondary: {
                    light: 'rgba(248, 181, 73, 1)',
                    main: 'rgba(246, 161, 25, 1.0)',
                    dark: 'rgba(236, 149, 9, 1)',
                    contrastText: 'rgba(255, 255, 255, 1)',
                },
                primary: {
                    light: 'rgb(27, 93, 143, 1)',
                    main: 'rgba(15, 51, 79, 1)',
                    dark: 'rgb(11, 37, 58, 1)',
                    contrastText: 'rgba(255, 255, 255, 1)',
                },
            },
        },
    },
    simulationenr: {
        theme: {
            palette: {
                primary: {
                    light: 'rgba(210, 227, 175, 1)',
                    main: 'rgb(130,175,38)',
                    dark: 'rgba(54, 101, 0, 1)',
                },
                secondary: {
                    light: 'rgba(210, 230, 230, 1)',
                    main: 'rgba(65, 155, 145, 1)',
                    dark: 'rgba(21, 79, 71, 1)',
                },
            },
        },
    },
    testbench: {
        envList: ['fhe', 'fheconnect', 'cocoon', 'homing', 'lacin', 'domalisa', 'accesshabitat', 'maestro', 'weezeo', 'niceenergie', 'mghabitat', 'idealys'],
        theme: {
            palette: {
                primary: {
                    light: 'rgba(198, 219, 225, 1)',
                    main: 'rgba(117, 154, 165, 1)',
                    dark: 'rgba(48, 68, 74, 1)',
                },
                secondary: {
                    light: 'rgba(203, 225, 222, 1)',
                    main: 'rgba(65, 155, 145, 1)',
                    dark: 'rgba(21, 79, 71, 1)',
                },
            },
        },
    },
    ticketsgit: {
        theme: {
            palette: {
                primary: {
                    light: 'rgb(240,188,142)',
                    main: 'rgba(222, 106, 0, 1)',
                    dark: 'rgb(99,48,0)',
                },
                secondary: {
                    light: 'rgb(255,121,112)',
                    main: 'rgba(226, 67, 41, 1)',
                    dark: 'rgb(133,39,24)',
                },
            },
        },
    },
    logging: {
        theme: {
            palette: {
                primary: {
                    light: 'rgb(162,178,177)',
                    main: 'rgb(71,98,99)',
                    dark: 'rgb(31,43,43)',
                },
                secondary: {
                    light: 'rgb(162,178,177)',
                    main: 'rgb(71,98,99)',
                    dark: 'rgb(31,43,43)',
                },
            },
        },
    },
};



// WEBPACK FOOTER //
// C:/FHE/Support/support-react-application/conf/environments.js